import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import emailjs from 'emailjs-com';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    paxCount: '',
    dayCount: '',
    adults: '',
    children: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare the template params
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      paxCount: formData.paxCount,
      dayCount: formData.dayCount,
      adults: formData.adults,
      children: formData.children,
      message: formData.message
    };

    emailjs
      .send(
        'service_vba4rnf',       
        'template_rklks4c',      
        templateParams,
        'O_P-hd-7QSG-kQe0Z'        
      )
      .then(() => {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phoneNumber: '',
          paxCount: '',
          dayCount: '',
          adults: '',
          children: '',
          message: ''
        });
      })
      .catch((error) => console.error(error));
  };

  return (
    <Container className="my-5">
      <h3 className="text-center mb-4">Plan your Trip With Escapio Travels</h3>

      {submitted && (
        <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>
          Thank you! We’ll contact you soon.
        </Alert>
      )}

      <Form onSubmit={handleSubmit} className="p-4 shadow rounded bg-light">
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Your Name"
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Your Email Address"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>WhatsApp Number</Form.Label>
          <PhoneInput
            country={'lk'}
            value={formData.phoneNumber}
            onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
            inputProps={{
              name: 'phoneNumber',
              required: true,
              autoFocus: true
            }}
            inputClass="form-control"
          />
        </Form.Group>

        <Row>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Pax Count</Form.Label>
              <Form.Control
                type="number"
                name="paxCount"
                value={formData.paxCount}
                onChange={handleChange}
                placeholder="Total People"
                min="1"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Day Count</Form.Label>
              <Form.Control
                type="number"
                name="dayCount"
                value={formData.dayCount}
                onChange={handleChange}
                placeholder="Days"
                min="1"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Adults</Form.Label>
              <Form.Control
                type="number"
                name="adults"
                value={formData.adults}
                onChange={handleChange}
                placeholder="No. of Adults"
                min="0"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Children</Form.Label>
              <Form.Control
                type="number"
                name="children"
                value={formData.children}
                onChange={handleChange}
                placeholder="No. of Children"
                min="0"
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Message or Special Request</Form.Label>
          <Form.Control
            as="textarea"
            name="message"
            rows={4}
            value={formData.message}
            onChange={handleChange}
            placeholder="Tell us more about your travel plans..."
          />
        </Form.Group>

        <Button type="submit" variant="dark" className="w-100">
          Submit Inquiry
        </Button>
      </Form>
    </Container>
  );
}

export default ContactForm;
